import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_7_LOCP_BANNER_IMAGES_250128 } from "@faire/retailer-settings/FE_BATCH_7_LOCP_BANNER_IMAGES_250128";

export const useSettingLoggedOutCategoryPageBannerImages = (): boolean => {
  return useSetting(FE_BATCH_7_LOCP_BANNER_IMAGES_250128);
};

export const useAssignSettingLoggedOutCategoryPageBannerImages = () =>
  useAssignSetting(FE_BATCH_7_LOCP_BANNER_IMAGES_250128);
